import React from 'react';
import LandlordToolkitLayout from '../../components/landlord-toolkit/LandlordToolkitLayout';
import ResourcesPage from '../resources/ResourcesPage';

const RentalResourcesLayoutPage: React.FC = () => {
  return (
    <LandlordToolkitLayout title="Rental Resources">
      <div className="w-full">
        <ResourcesPage />
      </div>
    </LandlordToolkitLayout>
  );
};

export default RentalResourcesLayoutPage;
